import * as Sentry from "@sentry/react";

import { salesforceMapSearchIdSchema } from "@/features/salesforceIntegration/schemas/salesforceContext";

/** Salesforceのレコード ID を保管するsessionStorageキー。 */
export const SALESFORCE_MAP_SEARCH_ID_STORAGE_KEY = "salesforceMapSearchId";

/**
 * SalesforceのレコードID（salesforceMapSearchId）をsessionStorageへ保存する。
 * タブを閉じたら消える寿命で要件を満たすため、sessionStorageを使う。
 */
export const saveSalesforceMapSearchId = (
  salesforceMapSearchId: string
): void => {
  sessionStorage.setItem(
    SALESFORCE_MAP_SEARCH_ID_STORAGE_KEY,
    salesforceMapSearchId
  );
};

/**
 * sessionStorageからSalesforceのレコードIDを読み出す。
 * 保存値が契約と異なる形に壊れている場合はSentryへ送りnullを返す。
 */
export const getSalesforceMapSearchId = (): string | null => {
  const raw = sessionStorage.getItem(SALESFORCE_MAP_SEARCH_ID_STORAGE_KEY);
  if (raw === null) return null;

  const parsed = salesforceMapSearchIdSchema.safeParse(raw);
  if (!parsed.success) {
    Sentry.captureException(
      new Error("salesforceMapSearchIdの保存値が契約と異なります"),
      { extra: { issues: parsed.error.issues } }
    );
    return null;
  }

  return parsed.data;
};

/**
 * SalesforceのレコードIDをsessionStorageから削除する。
 *
 * 1回限りの引き継ぎ値のため、登記取得リクエストの送信に成功した時点で呼び出して破棄する。
 * 残したままにすると、その後に地図で自由に探した無関係な物件のリクエストまで同じ
 * 地図検索レコードへ紐づき、連携時にSalesforce側のデータ整合が壊れる。
 * ログアウト時のクリーンアップ（`clearAuthData`）からも呼び出す。
 */
export const removeSalesforceMapSearchId = (): void => {
  sessionStorage.removeItem(SALESFORCE_MAP_SEARCH_ID_STORAGE_KEY);
};
